import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { secondhouseRoutes } from './secondhouse-routes';

@NgModule({
    imports: [RouterModule.forChild(secondhouseRoutes)],
    exports: [RouterModule],
})
export class SecondHouseRoutingModule {}
